import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function ensureTimezone(
  date: string | Date | Dayjs,
  targetTimeZone: string
) {
  const dateInTargetTZ = dayjs.tz(date, targetTimeZone);
  const isDateDayjs = dayjs.isDayjs(date);
  if (isDateDayjs && date.utcOffset() === dateInTargetTZ.utcOffset()) {
    return date;
  }

  return dateInTargetTZ;
}
